import type { Bruker } from '@klp/user';
import { BrukerRoller } from '@klp/user/types';

export type DevRolePreset = {
    id: string;
    labelKey: string;
    overrides: Partial<Bruker> | null;
};

export const DEV_ROLE_PRESETS: Array<DevRolePreset> = [
    {
        id: 'original',
        labelKey: 'devRoleSelector.original',
        overrides: null,
    },
    {
        id: 'forvalter-kontor',
        labelKey: 'devRoleSelector.forvalterKontor',
        overrides: {
            brukerId: 'asbjorn.loken@klp.no',
            epost: 'asbjorn.loken@klp.no',
            fornavn: 'Asbjørn',
            etternavn: 'Løken',
            fulltnavn: 'Asbjørn Løken',
            superOfficeId: 24275,
            isForvalter: true,
            isKontorForvalter: true,
            isHandelForvalter: false,
            isQAOkonomi: false,
            isProsjekteier: true,
            isProsjektleder: true,
            isProsjektdirektor: false,
            isProsjektkontroller: false,
            isForvaltningsdirektor: false,
            isUtviklingsdirektor: false,
            isAdministrerendedirektor: false,
            isOkonomisjef: false,
            isTekniskSjef: false,
            isOkonomi: false,
            isDrift: false,
            isLeverandorAnsvarlig: false,
            isBrukerAdministrator: false,
            isAdmin: true,
            isEDAdmin: false,
            region: 'Oslo',
            qaRegion: undefined,
            byggRegioner: ['Oslo'],
            byggTyper: ['kontor', 'annet', 'prosjekt', 'logistikk'],
            roller: [
                {
                    id: 12,
                    brukerId: 'asbjorn.loken@klp.no',
                    rolle: BrukerRoller.Prosjekteier,
                    region: 'Oslo',
                },
                {
                    id: 240,
                    brukerId: 'asbjorn.loken@klp.no',
                    rolle: BrukerRoller.Prosjektleder,
                    region: 'Oslo',
                },
            ],
            byggProsjektkontroller: [],
        },
    },
    {
        id: 'forvalter-kjopesenter',
        labelKey: 'devRoleSelector.forvalterKjopesenter',
        overrides: {
            brukerId: 'carl.christian.petersen@klp.no',
            epost: 'carl.christian.petersen@klp.no',
            fornavn: 'Carl Christian',
            etternavn: 'Petersen',
            fulltnavn: 'Carl Christian Petersen',
            superOfficeId: 14575,
            isForvalter: true,
            isKontorForvalter: false,
            isHandelForvalter: false,
            isQAOkonomi: false,
            isProsjekteier: false,
            isProsjektleder: false,
            isProsjektdirektor: false,
            isProsjektkontroller: false,
            isForvaltningsdirektor: false,
            isUtviklingsdirektor: false,
            isAdministrerendedirektor: false,
            isOkonomisjef: false,
            isTekniskSjef: false,
            isOkonomi: false,
            isDrift: false,
            isLeverandorAnsvarlig: false,
            isBrukerAdministrator: false,
            isAdmin: true,
            isEDAdmin: false,
            region: undefined,
            qaRegion: undefined,
            byggRegioner: [],
            byggTyper: [],
            roller: [
                {
                    id: 7,
                    brukerId: 'carl.christian.petersen@klp.no',
                    rolle: BrukerRoller.Forvalter,
                    region: 'Oslo',
                },
            ],
            byggProsjektkontroller: [],
        },
    },
    {
        id: 'okonomi',
        labelKey: 'devRoleSelector.okonomi',
        overrides: {
            brukerId: 'valarmathy.kailasapillai@klp.no',
            epost: 'valarmathy.kailasapillai@klp.no',
            fornavn: 'Valarmathy',
            etternavn: 'Kailasapillai',
            fulltnavn: 'Valarmathy Kailasapillai',
            superOfficeId: 14535,
            isForvalter: false,
            isKontorForvalter: true,
            isHandelForvalter: false,
            isQAOkonomi: false,
            isProsjekteier: false,
            isProsjektleder: false,
            isProsjektdirektor: false,
            isProsjektkontroller: false,
            isForvaltningsdirektor: false,
            isUtviklingsdirektor: false,
            isAdministrerendedirektor: false,
            isOkonomisjef: false,
            isTekniskSjef: false,
            isOkonomi: true,
            isDrift: false,
            isLeverandorAnsvarlig: false,
            isBrukerAdministrator: false,
            isAdmin: true,
            isEDAdmin: false,
            region: 'Oslo',
            qaRegion: undefined,
            byggRegioner: ['Oslo'],
            byggTyper: ['kontor', 'annet'],
            roller: [
                {
                    id: 351,
                    brukerId: 'valarmathy.kailasapillai@klp.no',
                    rolle: BrukerRoller.Okonomi,
                    region: 'Oslo',
                },
            ],
            byggProsjektkontroller: [],
        },
    },
    {
        id: 'okonomi-qa',
        labelKey: 'devRoleSelector.okonomiQA',
        overrides: {
            brukerId: 'solrunn.dokken.mork@klp.no',
            epost: 'solrunn.dokken.mork@klp.no',
            fornavn: 'Solrunn Dokken',
            etternavn: 'Mork',
            fulltnavn: 'Solrunn Dokken Mork',
            superOfficeId: 14555,
            isForvalter: false,
            isKontorForvalter: true,
            isHandelForvalter: false,
            isQAOkonomi: true,
            isProsjekteier: false,
            isProsjektleder: false,
            isProsjektdirektor: false,
            isProsjektkontroller: false,
            isForvaltningsdirektor: false,
            isUtviklingsdirektor: false,
            isAdministrerendedirektor: false,
            isOkonomisjef: false,
            isTekniskSjef: false,
            isOkonomi: true,
            isDrift: false,
            isLeverandorAnsvarlig: false,
            isBrukerAdministrator: false,
            isAdmin: true,
            isEDAdmin: false,
            region: 'Oslo',
            qaRegion: 'Oslo',
            byggRegioner: ['Oslo'],
            byggTyper: ['kontor'],
            roller: [
                {
                    id: 381,
                    brukerId: 'solrunn.dokken.mork@klp.no',
                    rolle: BrukerRoller.Okonomi,
                    region: 'Oslo',
                },
                {
                    id: 398,
                    brukerId: 'solrunn.dokken.mork@klp.no',
                    rolle: BrukerRoller.OkonomiQA,
                    region: 'Oslo',
                },
            ],
            byggProsjektkontroller: [
                {
                    id: 57,
                    brukerId: 'solrunn.dokken.mork@klp.no',
                    byggNummer: 'N21901',
                },
                {
                    id: 82,
                    brukerId: 'solrunn.dokken.mork@klp.no',
                    byggNummer: 'N90201',
                },
            ],
        },
    },
    {
        id: 'prosjektleder',
        labelKey: 'devRoleSelector.prosjektleder',
        overrides: {
            brukerId: 'henriette.haaland@klp.no',
            epost: 'henriette.haaland@klp.no',
            fornavn: 'Henriette',
            etternavn: 'Haaland',
            fulltnavn: 'Henriette Haaland',
            superOfficeId: 14515,
            isForvalter: true,
            isKontorForvalter: true,
            isHandelForvalter: false,
            isQAOkonomi: false,
            isProsjekteier: true,
            isProsjektleder: true,
            isProsjektdirektor: false,
            isProsjektkontroller: false,
            isForvaltningsdirektor: false,
            isUtviklingsdirektor: false,
            isAdministrerendedirektor: false,
            isOkonomisjef: false,
            isTekniskSjef: false,
            isOkonomi: false,
            isDrift: false,
            isLeverandorAnsvarlig: false,
            isBrukerAdministrator: false,
            isAdmin: true,
            isEDAdmin: false,
            region: 'Oslo',
            qaRegion: undefined,
            byggRegioner: ['Oslo'],
            byggTyper: ['kontor', 'prosjekt', 'annet'],
            roller: [
                {
                    id: 15,
                    brukerId: 'henriette.haaland@klp.no',
                    rolle: BrukerRoller.Prosjekteier,
                    region: 'Oslo',
                },
                {
                    id: 346,
                    brukerId: 'henriette.haaland@klp.no',
                    rolle: BrukerRoller.Prosjektleder,
                    region: 'Oslo',
                },
            ],
            byggProsjektkontroller: [],
        },
    },
];

export const DEV_ROLE_STORAGE_KEY = 'devRoleOverride';
